"use client";

import { ReCaptchaProvider } from "next-recaptcha-v3";

const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? "";

export default function ReCaptchaProviderWrapper({
	children,
}: {
	children: React.ReactNode;
}) {
	if (!siteKey) return <>{children}</>;
	return (
		<ReCaptchaProvider reCaptchaKey={siteKey}>{children}</ReCaptchaProvider>
	);
}
